import * as React from "react";
import type { SVGProps } from "react";
const SvgImIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="IM_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M42.667 262.656c0-99.03 73.6-177.323 162.133-177.323h614.4c88.533 0 162.133 78.294 162.133 177.323v498.688c0 99.03-73.6 177.323-162.133 177.323H204.8c-88.533 0-162.133-78.294-162.133-177.323V262.656zm85.333 0v498.688c0 46.08 34.39 83.456 76.8 83.456h614.4c42.41 0 76.8-37.376 76.8-83.456V262.656c0-46.08-34.39-83.456-76.8-83.456H204.8c-42.41 0-76.8 37.376-76.8 83.456zM446.677 363.52h100.651l69.248 185.6h3.456l69.248-185.6h100.693V691.2h-79.146V501.76h-2.347l-66.347 186.88h-47.701l-66.304-188.16h-2.347V691.2H446.72V363.52zM234.667 691.2v-56.79h44.416V420.268h-44.416V363.52h163.84v56.79H354.09v214.1h44.416v56.79h-163.84z"
    />
  </svg>
);
export default SvgImIcon;
